import {Line, mixins} from 'vue-chartjs';
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  data () {
    return {
      options: {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            },
            gridLines: {
              display: true
            }
          }],
          xAxes: [ {
            gridLines: {
              display: false
            }
          }]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false, 
        plugins:{
          datalabels: {
            display: false, 
          }
        },
      }
    };
  },
  mounted () {
    // this.chartData is created in the mixin
    this.renderChart(this.chartData, this.options);
  }
};